import { useCallback, useEffect, useState } from "react";
import { listPages } from "../../../api/pagesApi";
import { listSections } from "../../../api/sectionsApi";
import { getApiErrorMessage } from "../../../api/unwrapApiResponse";

const CAREERS_SLUG = "careers";
const POSITIONS_SECTION_KEY = "open-positions";

export function usePositionsSection() {
  const [sectionId, setSectionId] = useState(null);
  const [pageId, setPageId] = useState(null);
  const [pageName, setPageName] = useState("");
  const [sectionName, setSectionName] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const resolve = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const pages = await listPages();
      const list = Array.isArray(pages) ? pages : [];
      const careersPage =
        list.find((p) => (p.slug || "").toLowerCase() === CAREERS_SLUG) ||
        list.find((p) => (p.name || "").toLowerCase() === "careers");

      if (!careersPage) {
        setError(
          'No Careers page found. Create a page with slug "careers" first.'
        );
        setSectionId(null);
        return;
      }

      const sections = await listSections(careersPage.id);
      const sectionList = Array.isArray(sections) ? sections : [];
      const positionsSection =
        sectionList.find(
          (s) => (s.sectionType || "").toLowerCase() === "positions"
        ) ||
        sectionList.find(
          (s) => (s.key || "").toLowerCase() === POSITIONS_SECTION_KEY
        );

      if (!positionsSection) {
        setError(
          'No open positions section found on the Careers page. Add a section with type "positions".'
        );
        setPageId(careersPage.id);
        setPageName(careersPage.name || "Careers");
        setSectionId(null);
        return;
      }

      setPageId(careersPage.id);
      setPageName(careersPage.name || "Careers");
      setSectionId(positionsSection.id);
      setSectionName(positionsSection.name || "Open Positions");
    } catch (err) {
      setError(getApiErrorMessage(err));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    resolve();
  }, [resolve]);

  return {
    sectionId,
    pageId,
    pageName,
    sectionName,
    loading,
    error,
    reload: resolve,
  };
}
